import { render } from "./SearchResult.vue?vue&type=template&id=84934fd0&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=84934fd0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-84934fd0"

export default script